import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { addDefaultGtag, injectGoogleTagManagerContainer } from 'config/helper';

export const useGoogleTagManager = () => {
  const {commonDetailsData, commonDetailsDataLoading} = useSelector(({common}) => common);
  const headerSection = commonDetailsData?.header_section;

  const isInitializedRef = useRef(false);
  const currentGtmIdRef = useRef(null);

  useEffect(() => {
    if (commonDetailsDataLoading) {
      return;
    }

    const defaultGtmId = "G-NDKLCMRWEZ";
    const gtmId = headerSection?.analytic_google_tag_manager_id;

    if (isInitializedRef.current && currentGtmIdRef.current === gtmId) {
      return;
    }

    // Defer GTM loading until page is interactive to improve initial load performance
    const initializeGTM = () => {
      if (gtmId) {
        if (gtmId.startsWith("GTM-")) {
          injectGoogleTagManagerContainer(gtmId);
        } else {
          addDefaultGtag(gtmId);
        }
        isInitializedRef.current = true;
        currentGtmIdRef.current = gtmId;
      } else if (!isInitializedRef.current && headerSection) {
        addDefaultGtag(defaultGtmId);
        isInitializedRef.current = true;
        currentGtmIdRef.current = defaultGtmId;
      }
    };

    // Use requestIdleCallback for better performance, fallback to setTimeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initializeGTM, { timeout: 2000 });
    } else {
      setTimeout(initializeGTM, 2000);
    }
  }, [commonDetailsDataLoading, headerSection]);
};
